export const REACT_RECAPTCH_KEY = process.env.REACT_APP_RECAPTCH_KEY;

export const IS_LOCAL_DEBUG = window.location.host.startsWith("localhost") || window.location.host.startsWith("127.0.0.1") || window.location.host.startsWith("innerdevpc");
export const REACT_APP_BASE_URL = IS_LOCAL_DEBUG ? process.env.REACT_APP_BASE_URL : window.location.origin;

export const IS_DEBUG = process.env.REACT_APP_IS_DEBUG === "true";
export const QUICK_DEBUG = process.env.REACT_APP_QUICK_DEBUG === "true";
export const TEMP_SAVE_MTABLE_STATE = true; // пока нет сокетов временно сохраняем состояние таблицы майнеров
export const SHOW_LOGS = process.env.REACT_APP_SHOW_LOGS === "true";
export const SERVER_TIMEZONE = "Europe/Moscow";
export const SHOW_ELECTRIC_SCHEME_TOOLBAR = false;
export const SHOW_ELECTRIC_SCHEME_TABS = true;
export const SHOW_ELECTRIC_RELOAD_BUTTON = false;
export const VISIBILITY_TIMEOUT_MS = IS_DEBUG ? 0 : 300000;
export const SHOW_SCHEMES = true;

export const ALLOW_WEEKDAY_PLANS = process.env.REACT_APP_ALLOW_WEEKDAY_PLANS === "true";
export const ALLOW_BOOST_MINER = process.env.REACT_APP_ALLOW_BOOST_MINER === "true";
export const ALLOW_CHECK_MINER = process.env.REACT_APP_ALLOW_CHECK_MINER === "true";

export const APP_THEME = process.env.REACT_APP_THEME;
export const APP_TITLE = process.env.REACT_APP_TITLE;
export const WLP202603 = process.env.REACT_APP_BRAND_THEME === "wattlord";
export const WLP_SUBSCRIBE_NOLOGON = true;

export const MINER_POOLS = {
  ams: {
    0: process.env.REACT_APP_POOL_AMS ?? "",
    1: "ru.gate1.wattmanor.com:",
  },
  sgp: {
    0: process.env.REACT_APP_POOL_SGP ?? "",
    1: "ru.gate1.wattmanor.com:",
  },
  nyc: {
    0: process.env.REACT_APP_POOL_NYC ?? "",
    1: process.env.REACT_APP_POOL_NYC ?? "",
  },
};

//
// Запасная опция for equihash (пользователю не показываем):
// ru.gate1.wattmanor.com:28883 -> nyc.wattmanor.com:3888

export const RACK_UNIT = 27; // должен соответствовать $RACK_UNIT из variables.scss
export const SECONDS_MS = 1000;

export const ALGO_PORTS = {
  sha256: {
    main: 8889,
    alternative: [8889, 18889, 28889],
  },
  scrypt: {
    main: 8889,
    alternative: [8889, 18889, 28889],
  },
  equihash: {
    main: 8883,
    alternative: [8883, 18883, 8883],
  },
};

export const USE_TEST_POOL = process.env.REACT_APP_USE_TEST_POOL;

// 4 test
export const TEST_TOKEN = process.env.REACT_APP_TEST_TOKEN;
export const USE_MOBX_CREATE_MINER_PROFILE_MODAL = true;
export const WITH_CREDENTIALS = !window.location.host.startsWith("localhost");
export const SITE_KIND = process.env.REACT_APP_KIND;
